import { useEffect, useState } from 'react';
import { fetchSettings } from './sanity';
import Page from './components/page/Page';
import { Route, Routes, useNavigate } from 'react-router';
import WrappedSpinner from './components/kit/WrappedSpinner';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { settingsState } from './state';

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const setSettings = useSetRecoilState(settingsState);
  const settings = useRecoilValue(settingsState);


  const navigate = useNavigate();




  useEffect(() => {
    console.log(window.location.pathname)
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        const data = await fetchSettings();
        await setSettings(data);

        if (window.location.pathname.length < 2) {
          navigate("/home")
        }
        setIsLoading(false);
      } catch (error) {
        setIsError(true)
        setIsLoading(false)
        console.error('Error fetching settings:', error);
      } finally {

      }
    };
    loadData();
  }, []);

  return (
    <>

      {isLoading && <div className='h-screen w-screen bg-gray-200 flex justify-center items-center'><WrappedSpinner size='xl' text='Loading...' /></div>}
      {isError && <div className='sm:w-4/5 lg:w-3/5'>
        <h2>Omlouváme se, tato stránka je momentálně nedostupná</h2>
        <p className='text-xl'>
          Vypadá to, že stránka, kterou se pokoušíte navštívit, je dočasně nedostupná. Může to být kvůli údržbě nebo neočekávanému problému. Prosím, zkuste to znovu později, nebo nás kontaktujte přímo na <a href="mailto:idako@seznam.cz">idako@seznam.cz</a>.
        </p>
      </div>}

      {!isError && !isLoading && settings && <>
        <Header settings={settings} />
        <section className="min-h-[80vh]">
          <Routes>
            <Route path="/:slug" element={<Page settings={settings} />} />
          </Routes>
        </section>
        <Footer settings={settings} />
      </>
      }
    </>

  );
};

export default HomePage;